module.exports = __webpack_public_path__ + "img/co_wrapbg9.4956faeb.png";